import { render, staticRenderFns } from "./RoleMembers.vue?vue&type=template&id=45b403a0&"
import script from "./RoleMembers.vue?vue&type=script&lang=js&"
export * from "./RoleMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports